import React, { useEffect, useState, useCallback, memo } from "react";
import { ReactComponent as TrashIcon } from "../../../assets/icons/trashIcon.svg";
import { ReactComponent as EditIcon } from "../../../assets/icons/EditBtn.svg";
import Button from "../../extra/Button";
import Pagination from "../../extra/Pagination";
import Table from "../../extra/Table";
import Searching from "../../extra/Searching";
import { connect, useDispatch, useSelector } from "react-redux";
import { OPEN_DIALOGUE } from "../../store/dialogue/dialogue.type";
import { getShortsApi, deleteShort } from "../../store/shorts/shorts.action";
import { updateFeature } from "../../store/shorts/shorts.action";
import { warning } from "../../../util/Alert";
import { covertURl } from "../../../util/AwsFunction";
import UserImage from "../../../assets/images/8.jpg";
import $ from "jquery";
import { useNavigate } from "react-router-dom";
import { LOADING } from "../../store/shorts/shorts.type";
import FeatureToggle from "../../extra/ToggleButton";
import { getVideoApi } from "../../store/video/video.action";
import ReactHlsPlayer from "react-hls-player";
import { getUser, getUserChannels } from "../../store/user/user.action";
const MemoizedVideoIframe = React.memo(
  ({ row, index }) => (
    <div key={index}>
      <iframe
        key={row?._id}
        title={row?.title}
        src={row.adminVideoUrl}
        style={{ borderRadius: "10px" }}
        height="250px"
        width="200px"
        loading="lazy"
        allowFullScreen={true}
      />
    </div>
  ),
  (prevProps, nextProps) =>
    prevProps.row.adminVideoUrl === nextProps.row.adminVideoUrl
);

function ManageShorts(props) {
  const { startDate, endDate, multiButtonSelectData } = props;
  const dispatch = useDispatch();
  const [checkBox, setCheckBox] = useState();
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(25);
  const [verificationRequests, setVerificationRequests] = useState();
  const [actionPagination, setActionPagination] = useState("delete");
  const [actionEnteries, setActionEnteries] = useState("25");
  const [actionFilter, setActionFilter] = useState("All");
  const [selectCheckData, setSelectCheckData] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [search, setSearch] = useState();
  const [data, setData] = useState([]);
  const [showURLs, setShowURLs] = useState([]);
  const [showVideoURLs, setShowVideoURLs] = useState([]);
  //checking filter is true or false
  const [hasActiveFilters, setHasActiveFilters] = useState(false);
  const navigate = useNavigate();
  const { shortsData, totalShorts } = useSelector((state) => state.shorts);
  const { getUserChannel, totalUserChannel } = useSelector(
    (state) => state.user
  );
  //get the channelid and
  const options = getUserChannel.map((user) => ({
    label: user.fullName,
    id: user.channelId,
  }));
  const [filter, setFilter] = useState({
    filter1: "",
    filter2: "",
    filter3: "",
  });
  // const actionFilterHandle = (filter) => {
  //   if (filter === "Featured") {
  //     dispatch(getShortsApi("featured", 2, page, size, startDate, endDate));
  //   } else if (filter === "Not Featured") {
  //     dispatch(getShortsApi("non-featured", 2, page, size, startDate, endDate));
  //   } else {
  //     dispatch(getShortsApi("All", 2, page, size, startDate, endDate));
  //   }
  // };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  $(document).ready(function () {
    $("img").bind("error", function () {
      // Set the default image
      $(this).attr("src", UserImage);
    });
  });

  const handleRowsPerPage = (value) => {
    setPage(1);
    setSize(value);
  };

  // useCallback to memoize the function and prevent unnecessary re-renders
  const handleSelectCheckData = useCallback((e, row) => {
    const checked = e.target.checked;
    if (checked) {
      setSelectCheckData((prevSelectedRows) => [...prevSelectedRows, row]);
    } else {
      setSelectCheckData((prevSelectedRows) =>
        prevSelectedRows.filter((selectedRow) => selectedRow._id !== row._id)
      );
    }
  }, []);

  const handleSelectAll = (event) => {
    const checked = event.target.checked;
    setSelectAllChecked(checked);
    if (checked) {
      setSelectCheckData([...data]);
    } else {
      setSelectCheckData([]);
    }
  };

  const paginationSubmitButton = () => {
    const selectCheckDataGetId = selectCheckData?.map((item) => item?._id);
    if (actionPagination === "delete") {
      const data = warning();
      data
        .then((res) => {
          if (res) {
            const yes = res.isConfirmed;
            if (yes) {
              props.deleteShort(selectCheckDataGetId);
            }
          }
        })
        .catch((err) => console.log(err));
    }
    if (actionPagination === "featured") {
      const selectCheckDataGetId = selectCheckData?.map((item) => ({
        uniqueVideoId: item?.uniqueVideoId,
        feature: true,
      }));
      const data = warning();
      data
        .then((res) => {
          if (res.isConfirmed) {
            props.updateFeature(
              selectCheckDataGetId,
              2,
              page,
              size,
              startDate,
              endDate
            );
          }
        })
        .catch((err) => console.log(err));
    }
    if (actionPagination === "not featured") {
      const selectCheckDataGetId = selectCheckData?.map((item) => ({
        uniqueVideoId: item?.uniqueVideoId,
        feature: false,
      }));
      const data = warning();
      data
        .then((res) => {
          if (res.isConfirmed) {
            props.updateFeature(
              selectCheckDataGetId,
              2,
              page,
              size,
              startDate,
              endDate
            );
          }
        })
        .catch((err) => console.log(err));
    }
  };

  const handleDeleteVideo = (row) => {
    const data = warning();
    data
      .then((res) => {
        if (res) {
          if (res.isConfirmed) {
            const id = row?._id;
            props.deleteShort(id);
          }
        }
      })
      .catch((err) => console.log(err));
  };

  // Remove data dependency from useEffect for fetching URLs
  //handling the search filter
  const handleFilterData = useCallback(
    (filteredData) => {
      if (typeof filteredData === "string") {
        setSearch(filteredData);
      } else {
        const updatedData = filteredData.map((newItem) => {
          const existingItem = data.find((item) => item._id === newItem._id);
          return existingItem ? existingItem : newItem; // Keep the original object if it exists
        });
        // Create a *new* array only if the content has changed
        if (
          updatedData.length !== data.length ||
          !updatedData.every((item, index) => item === data[index])
        ) {
          setData(updatedData);
        }
      }
    },
    [data, setData, setSearch]
  );

  const handleEdit = (row, type) => {
    dispatch({
      type: OPEN_DIALOGUE,
      payload: {
        type: type,
        data: row,
        start: page,
        limit: size,
        startDate: startDate,
        endDate: endDate,
      },
    });

    let dialogueData_ = {
      dialogue: true,
      type: type,
      dialogueData: row,
    };
    localStorage.setItem("dialogueData", JSON.stringify(dialogueData_));
  };

  const videoMapData = [
    {
      Header: "checkBox",
      width: "20px",
      Cell: ({ row, index }) => (
        <input
          index={index}
          type="checkbox"
          checked={selectCheckData.some(
            (selectedRow) => selectedRow?._id === row?._id
          )}
          onChange={(e) => handleSelectCheckData(e, row)}
        />
      ),
    },
    {
      Header: "NO",
      body: "no",
      Cell: ({ index }) => (
        <span className="  text-nowrap" index={index}>
          {(page - 1) * size + parseInt(index) + 1}
        </span>
      ),
    },
    {
      Header: "Video",
      body: "video",
      Cell: React.useCallback(
        ({ row, index }) => (
          <MemoizedVideoIframe key={index} row={row} index={index} />
        ),
        []
      ),
    },
    {
      Header: "TITLE",
      body: "title",
      Cell: ({ row, index }) => (
        <div
          index={index}
          style={{
            maxWidth: "350px",
            marginLeft: "auto",
            marginRight: "auto",
          }}
          title={row?.title}
        >
          {row?.title}
        </div>
      ),
    },
    {
      Header: "ADDED BY",
      body: "addedBy",
      Cell: ({ row, index }) => (
        <div
          index={index}
          className="d-flex align-items-center justify-content-center"
          style={{ cursor: "pointer" }}
          onClick={() =>
            navigate("/admin/userProfile", { state: { id: row?.userId } })
          }
        >
          <img
            index={index}
            src={row.image}
            width="40px"
            height="40px"
            alt="User"
            onError={(e) => {
              e.target.src = UserImage;
            }}
          />
          <span className="text-capitalize   cursorPointer text-nowrap">
            {row?.fullName}
          </span>
        </div>
      ),
    },
    {
      Header: "Feature Tag",
      body: "feature",
      Cell: ({ row, index }) => (
        <FeatureToggle
          index={index}
          type={"short"}
          row={row}
          updateFeature={props.updateFeature}
          page={page}
          size={size}
          startDate={startDate}
          endDate={endDate}
        />
      ),
    },
    {
      Header: "ACTION",
      body: "action",
      Cell: ({ row, index }) => (
        <div className="action-button" index={index}>
          <Button
            btnIcon={<EditIcon />}
            onClick={() => handleEdit(row, "editShort")}
          />
          <Button
            btnIcon={<TrashIcon />}
            onClick={() => handleDeleteVideo(row)}
          />
        </div>
      ),
    },
  ];

  useEffect(() => {
    dispatch(getShortsApi(filter, 2, page, size, startDate, endDate));
    dispatch(getUserChannels(page, 10000, startDate, endDate, "realUser"));
  }, [dispatch, startDate, endDate, page, size, actionFilter]);

  useEffect(() => {
    setData(shortsData);
    dispatch({
      type: LOADING,
      payload: {
        loading: true,
      },
    });
  }, [shortsData, dispatch]);

  return (
    <div>
      <div className="user-table mb-3">
        <div className="user-table-top">
          <div className="row align-items-start">
            <h5
              style={{
                fontWeight: "500",
                fontSize: "20px",
                marginTop: "5px",
                marginBottom: "4px",
              }}
            >
              Manage & Short
            </h5>
            <Searching
              //for api call
              start={page}
              limit={size}
              startDate={startDate}
              endDate={endDate}
              label={"Search for ID, Keyword, Title, Username "}
              placeholder={"Search..."}
              data={shortsData}
              type={"client"}
              setData={setData}
              onFilterData={handleFilterData}
              searchValue={search}
              customSelectDataShow={true}
              customSelectData={["Delete", "Featured", "Not Featured"]}
              actionPagination={actionPagination}
              setActionPagination={setActionPagination}
              paginationSubmitButton={paginationSubmitButton}
              customEnteriesData={["25", "50", "100", "150"]}
              actionEnteries={actionEnteries}
              setActionEnteries={setActionEnteries}
              handleRowsPerPage={handleRowsPerPage}
              customeSelectDataEnteriesShow={true}
              //filter records
              //for open the filter
              hasActiveFilters={hasActiveFilters}
              setHasActiveFilters={setHasActiveFilters}
              customeFilterData={["All", "Featured", "Not Featured"]}
              customFilterDataShow={true}
              actionFilter={actionFilter}
              setActionFilter={setActionFilter}
              handleFilterData={handleFilterData}
              filterType={"FilterShort"}
              firstField={true}
              firstFieldName={"Searching Clip"}
              secondField={true}
              secondFieldName={"Search Channel"}
              ModelName={"Searching Clip"}
              feature={true}
              options={options}
              setFilter={setFilter}
            />
          </div>
        </div>
        <Table
          data={data}
          mapData={videoMapData}
          serverPerPage={size}
          serverPage={page}
          handleSelectAll={handleSelectAll}
          selectAllChecked={selectAllChecked}
          type={"server"}
        />
        <div className="mt-3">
          <Pagination
            type={"server"}
            activePage={page}
            rowsPerPage={size}
            userTotal={totalShorts}
            setPage={setPage}
            handleRowsPerPage={handleRowsPerPage}
            handlePageChange={handlePageChange}
            //enteries
            customEnteriesData={["25", "50", "100", "150"]}
            actionEnteries={actionEnteries}
            setActionEnteries={setActionEnteries}
            customeSelectDataEnteriesShow={true}
          />
        </div>
      </div>
    </div>
  );
}

export default connect(null, {
  getShortsApi,
  deleteShort,
  updateFeature,
})(ManageShorts);
